import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { JobListComponent } from './components/pages/job-list/job-list.component';
import { JobDetailsComponent } from './components/pages/job-details/job-details.component';
import { PostAJobComponent } from './components/pages/post-a-job/post-a-job.component';
import { CandidateDetailsComponent } from './components/pages/candidate-details/candidate-details.component';
import { CompanyDetailsComponent } from './components/pages/company-details/company-details.component';
import { LoginComponent } from './components/pages/login/login.component';
import { CreateAccountComponent } from './components/pages/create-account/create-account.component';
import { CompletarEmpresaComponent } from './components/pages/completar-empresa/completar-empresa.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { TerminosComponent } from './components/pages/terminos/terminos.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { VacantListComponent } from './components/pages/vacant-and-proyects/vacant-and-proyects.component';
import { CandidatesComponent } from './components/pages/candidates/candidates.component';
import { ChangePasswordComponent } from './components/pages/change-password/change-password.component';
import { HomeLoginComponent } from './components/pages/home-login/home-login.component';
import { PasswordComponent } from './components/pages/change-password/password/password.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { VerifyAccountComponent } from './components/pages/verify-account/verify-account/verify-account.component';
import { VerificationCodeComponent } from './components/pages/verify-account/verify-account/verification-code/verification-code.component';
import { AuthGuardGuard } from './services/auth-guard/auth-guard.guard';
import { AdminGuard } from './services/admin-guard/admin.guard';
import { CvVaultComponent } from './components/pages/cv-vault/cv-vault.component';
import { MisSuscripcionesComponent } from './components/pages/mis-suscripciones/mis-suscripciones.component';
import { AdminScraperComponent } from './components/pages/admin-scraper/admin-scraper.component';
import { AdminSocialComponent } from './components/pages/admin-social/admin-social.component';
import { AdminVacantesComponent } from './components/pages/admin-vacantes/admin-vacantes.component';
import { AdminConfigComponent } from './components/pages/admin-config/admin-config.component';
import { AdminUsuariosComponent } from './components/pages/admin-usuarios/admin-usuarios.component';
import { AlertsPanelComponent } from './components/pages/alerts-panel/alerts-panel.component';
import { StripeSuccessComponent } from './components/pages/stripe-success/stripe-success.component';
import { AdminSuscripcionesComponent } from './components/pages/admin-suscripciones/admin-suscripciones.component';
import { AdminStripeComponent } from './components/pages/admin-stripe/admin-stripe.component';
import { AdminGuruMatchComponent } from './components/pages/admin-gurumatch/admin-gurumatch.component';
import { FreeOnboardingComponent } from './components/pages/free-onboarding/free-onboarding.component';

const routes: Routes = [
    {path: '', component: HomeComponent,  },
    {path: 'acceder', component: LoginComponent, },
    {path: 'acerca-de-nosotros', component: AboutComponent, canActivate:[AuthGuardGuard]},
    {path: 'cambiar-password', component: ChangePasswordComponent},
    {path: 'cambiar-password/:rol', component: PasswordComponent},
    {path: 'candidatos', component: CandidatesComponent, canActivate:[AuthGuardGuard]},
    {path: 'candidatos/detalles/:idCandidato', component: CandidateDetailsComponent},
    {path: 'completar-empresa', component: CompletarEmpresaComponent},
    {path: 'contacto', component: ContactComponent},
    {path: 'editar-perfil', component: ProfileComponent },
    {path: 'terminos', component: TerminosComponent },
    {path: 'empresa', component: HomeLoginComponent, canActivate:[AuthGuardGuard]},
    {path: 'empresas/detalles/:idEmpresa', component: CompanyDetailsComponent},
    {path: 'planes', component: PricingComponent},
    {path: 'postulados', component: VacantListComponent, canActivate:[AuthGuardGuard]},
    {path: 'registrarse', component: CreateAccountComponent},
    {path: 'vacantes', component: JobListComponent},
    {path: 'vacante/nuevo', component: PostAJobComponent, canActivate:[AuthGuardGuard]},
    {path: 'vacante/editar', component: PostAJobComponent, canActivate:[AuthGuardGuard]},
    {path: 'vacantes/detalles/:vacante', component: JobDetailsComponent},
    {path: 'mis-cvs', component: CvVaultComponent, canActivate: [AuthGuardGuard]},
    {path: 'mis-suscripciones', component: MisSuscripcionesComponent, canActivate: [AuthGuardGuard]},
    {path: 'free-onboarding', component: FreeOnboardingComponent, canActivate: [AuthGuardGuard]},
    {path: 'mis-alertas', component: AlertsPanelComponent, canActivate: [AuthGuardGuard]},
    {path: 'planes/exito', component: StripeSuccessComponent, canActivate: [AuthGuardGuard]},
    {path: 'admin', redirectTo: 'admin/scraper', pathMatch: 'full'},
    {path: 'admin/scraper', component: AdminScraperComponent, canActivate: [AdminGuard]},
    {path: 'admin/vacantes', component: AdminVacantesComponent, canActivate: [AdminGuard]},
    {path: 'admin/usuarios', component: AdminUsuariosComponent, canActivate: [AdminGuard]},
    {path: 'admin/config', component: AdminConfigComponent, canActivate: [AdminGuard]},
    {path: 'admin/social', component: AdminSocialComponent, canActivate: [AdminGuard]},
    {path: 'admin/suscripciones', component: AdminSuscripcionesComponent, canActivate: [AdminGuard]},
    {path: 'admin/gurumatch', component: AdminGuruMatchComponent, canActivate: [AdminGuard]},
    {path: 'admin/stripe', component: AdminStripeComponent, canActivate: [AdminGuard]},
    {path: 'oauth/callback/linkedin', component: LoginComponent},
    {path: 'verificar', component: VerificationCodeComponent},
    {path: 'verificar/:rol', component: VerifyAccountComponent},
    {path: '**', component: ErrorComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
